import { inventoryItemsService } from './inventory/inventoryItemsService';
import { inventoryLotsService } from './inventory/inventoryLotsService';
import { inventorySamplesService } from './inventory/inventorySamplesService';
import { roastedBulkService } from './inventory/roastedBulkService';
import { finishedGoodsService } from './inventory/finishedGoodsService';
import { inventoryWorkOrderService } from './inventory/inventoryWorkOrderService';

export const inventoryService = {
  ...inventoryItemsService,
  ...inventoryLotsService,
  ...inventorySamplesService,
  ...roastedBulkService,
  ...finishedGoodsService,
  createFromWorkOrder: inventoryWorkOrderService.createFromWorkOrder,
};
